/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  PatchSettingsJumphostsKeyBody,
  PostSettingsJumphostsBody,
  PostTablesSettingsJumphosts200,
  PostTablesSettingsJumphostsBody,
  PutSettingsJumphostsKeyBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Adds jumphost to global settings and its properties
 * @summary Add jumphost to global settings
 */
export const postSettingsJumphosts = (
  postSettingsJumphostsBody: PostSettingsJumphostsBody,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/settings/jumphosts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postSettingsJumphostsBody,
    signal,
  });
};

export const getPostSettingsJumphostsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsJumphosts>>,
    TError,
    { data: PostSettingsJumphostsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsJumphosts>>,
  TError,
  { data: PostSettingsJumphostsBody },
  TContext
> => {
  const mutationKey = ['postSettingsJumphosts'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsJumphosts>>,
    { data: PostSettingsJumphostsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postSettingsJumphosts(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettingsJumphostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsJumphosts>>
>;
export type PostSettingsJumphostsMutationBody = PostSettingsJumphostsBody;
export type PostSettingsJumphostsMutationError = unknown;

/**
 * @summary Add jumphost to global settings
 */
export const usePostSettingsJumphosts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsJumphosts>>,
      TError,
      { data: PostSettingsJumphostsBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsJumphosts>>,
  TError,
  { data: PostSettingsJumphostsBody },
  TContext
> => {
  const mutationOptions = getPostSettingsJumphostsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes specific jumphost defined by its ID
 * @summary Delete jumphost item
 */
export const deleteSettingsJumphostsKey = (key: string) => {
  return apiClient<unknown>({
    url: `/settings/jumphosts/${key}`,
    method: 'DELETE',
  });
};

export const getDeleteSettingsJumphostsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['deleteSettingsJumphostsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return deleteSettingsJumphostsKey(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSettingsJumphostsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>
>;

export type DeleteSettingsJumphostsKeyMutationError = unknown;

/**
 * @summary Delete jumphost item
 */
export const useDeleteSettingsJumphostsKey = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettingsJumphostsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getDeleteSettingsJumphostsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates specific jumphost properties, defined by its ID
 * @summary Update specific jumphost properties
 */
export const patchSettingsJumphostsKey = (
  key: string,
  patchSettingsJumphostsKeyBody: PatchSettingsJumphostsKeyBody,
) => {
  return apiClient<unknown>({
    url: `/settings/jumphosts/${key}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchSettingsJumphostsKeyBody,
  });
};

export const getPatchSettingsJumphostsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettingsJumphostsKey>>,
    TError,
    { key: string; data: PatchSettingsJumphostsKeyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettingsJumphostsKey>>,
  TError,
  { key: string; data: PatchSettingsJumphostsKeyBody },
  TContext
> => {
  const mutationKey = ['patchSettingsJumphostsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettingsJumphostsKey>>,
    { key: string; data: PatchSettingsJumphostsKeyBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return patchSettingsJumphostsKey(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettingsJumphostsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettingsJumphostsKey>>
>;
export type PatchSettingsJumphostsKeyMutationBody =
  PatchSettingsJumphostsKeyBody;
export type PatchSettingsJumphostsKeyMutationError = unknown;

/**
 * @summary Update specific jumphost properties
 */
export const usePatchSettingsJumphostsKey = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettingsJumphostsKey>>,
      TError,
      { key: string; data: PatchSettingsJumphostsKeyBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettingsJumphostsKey>>,
  TError,
  { key: string; data: PatchSettingsJumphostsKeyBody },
  TContext
> => {
  const mutationOptions = getPatchSettingsJumphostsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Rewrites jumphost properties, defined by its ID
 * @summary Rewrite jumphost properties
 */
export const putSettingsJumphostsKey = (
  key: string,
  putSettingsJumphostsKeyBody: PutSettingsJumphostsKeyBody,
) => {
  return apiClient<unknown>({
    url: `/settings/jumphosts/${key}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putSettingsJumphostsKeyBody,
  });
};

export const getPutSettingsJumphostsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsJumphostsKey>>,
    TError,
    { key: string; data: PutSettingsJumphostsKeyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsJumphostsKey>>,
  TError,
  { key: string; data: PutSettingsJumphostsKeyBody },
  TContext
> => {
  const mutationKey = ['putSettingsJumphostsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsJumphostsKey>>,
    { key: string; data: PutSettingsJumphostsKeyBody }
  > = (props) => {
    const { key, data } = props ?? {};

    return putSettingsJumphostsKey(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutSettingsJumphostsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsJumphostsKey>>
>;
export type PutSettingsJumphostsKeyMutationBody = PutSettingsJumphostsKeyBody;
export type PutSettingsJumphostsKeyMutationError = unknown;

/**
 * @summary Rewrite jumphost properties
 */
export const usePutSettingsJumphostsKey = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsJumphostsKey>>,
      TError,
      { key: string; data: PutSettingsJumphostsKeyBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsJumphostsKey>>,
  TError,
  { key: string; data: PutSettingsJumphostsKeyBody },
  TContext
> => {
  const mutationOptions = getPutSettingsJumphostsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Downloads jumphosts public key
 * @summary Download jumphosts public key
 */
export const getSettingsJumphostsSshCert = (signal?: AbortSignal) => {
  return apiClient<unknown>({
    url: `/settings/jumphosts/ssh-cert`,
    method: 'GET',
    signal,
  });
};

export const getGetSettingsJumphostsSshCertQueryKey = () => {
  return [`/settings/jumphosts/ssh-cert`] as const;
};

export const getGetSettingsJumphostsSshCertQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSettingsJumphostsSshCertQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>
  > = ({ signal }) => getSettingsJumphostsSshCert(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSettingsJumphostsSshCertQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>
>;
export type GetSettingsJumphostsSshCertQueryError = unknown;

export function useGetSettingsJumphostsSshCert<
  TData = Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
          TError,
          Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsJumphostsSshCert<
  TData = Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
          TError,
          Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSettingsJumphostsSshCert<
  TData = Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Download jumphosts public key
 */

export function useGetSettingsJumphostsSshCert<
  TData = Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSettingsJumphostsSshCert>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSettingsJumphostsSshCertQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/settings/jumphosts
 */
export const postTablesSettingsJumphosts = (
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesSettingsJumphosts200>({
    url: `/tables/settings/jumphosts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesSettingsJumphostsBody,
    signal,
  });
};

export const getPostTablesSettingsJumphostsQueryKey = (
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
) => {
  return [
    `/tables/settings/jumphosts`,
    postTablesSettingsJumphostsBody,
  ] as const;
};

export const getPostTablesSettingsJumphostsQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
  TError = unknown,
>(
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesSettingsJumphostsQueryKey(postTablesSettingsJumphostsBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesSettingsJumphosts>>
  > = ({ signal }) =>
    postTablesSettingsJumphosts(postTablesSettingsJumphostsBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesSettingsJumphostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesSettingsJumphosts>>
>;
export type PostTablesSettingsJumphostsQueryError = unknown;

export function usePostTablesSettingsJumphosts<
  TData = Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
  TError = unknown,
>(
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
          TError,
          Awaited<ReturnType<typeof postTablesSettingsJumphosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSettingsJumphosts<
  TData = Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
  TError = unknown,
>(
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
          TError,
          Awaited<ReturnType<typeof postTablesSettingsJumphosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesSettingsJumphosts<
  TData = Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
  TError = unknown,
>(
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/settings/jumphosts
 */

export function usePostTablesSettingsJumphosts<
  TData = Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
  TError = unknown,
>(
  postTablesSettingsJumphostsBody: PostTablesSettingsJumphostsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesSettingsJumphosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesSettingsJumphostsQueryOptions(
    postTablesSettingsJumphostsBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
